export default __webpack_public_path__ + "../staticImages/sprite-rechnung.png";